module.exports = __webpack_public_path__ + "static/media/lock-white-icon.7b599de8.svg";